"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _uuid = require("uuid");

var _Select = require("./Select.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 下拉選單
 */
var Select = function Select(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      className = _ref.className,
      label = _ref.label,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      disabled = _ref.disabled,
      message = _ref.message,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      placeholder = _ref.placeholder,
      _ref$getPopupContaine = _ref.getPopupContainer,
      getPopupContainer = _ref$getPopupContaine === void 0 ? function () {
    return document.getElementById("root");
  } : _ref$getPopupContaine,
      dropdownStyle = _ref.dropdownStyle,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? false : _ref$row,
      mode = _ref.mode,
      showArrow = _ref.showArrow,
      variant = _ref.variant,
      _ref$allowClear = _ref.allowClear,
      allowClear = _ref$allowClear === void 0 ? true : _ref$allowClear;
  return /*#__PURE__*/_react.default.createElement(_Select.UiSelect, {
    row: row,
    variant: variant,
    className: className
  }, label && /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_antd.Select, {
    mode: mode,
    showArrow: showArrow,
    onChange: onChange,
    onClear: onClear,
    value: value,
    defaultValue: defaultValue,
    allowClear: allowClear,
    disabled: disabled,
    getPopupContainer: getPopupContainer,
    dropdownStyle: dropdownStyle,
    placeholder: placeholder
  }, options.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_antd.Select.Option, {
      key: (0, _uuid.v4)(),
      value: option.value,
      label: option.name
    }, option.name);
  })), message && /*#__PURE__*/_react.default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons",
    style: {
      fontSize: "20px"
    }
  }, "cancel"), message));
};

var _default = Select;
exports.default = _default;
Select.propTypes = {
  options: _propTypes.default.array,
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  message: _propTypes.default.string,
  value: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  onChange: _propTypes.default.func,
  row: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  mode: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  getPopupContainer: _propTypes.default.func,
  dropdownStyle: _propTypes.default.object,
  showArrow: _propTypes.default.bool,
  variant: _propTypes.default.string,
  allowClear: _propTypes.default.bool
};